import { render, staticRenderFns } from "./NewPartnerSiteTransformationModal.vue?vue&type=template&id=1816f602&"
import script from "./NewPartnerSiteTransformationModal.vue?vue&type=script&lang=js&"
export * from "./NewPartnerSiteTransformationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports